import {PASSPORT_TRANLSATE} from './consts'
import {PassportUserLocale} from './types'

export const getPassportLocalization = (keys: PassportUserLocale): PassportUserLocale => {
  return {...PASSPORT_TRANLSATE, ...keys}
}
